        
<!-- ============================================================== -->
<!-- Profile - style you can find in header.scss -->
<!-- ============================================================== -->
<!-- <a href="https://wrappixel.com/templates/materialpro-angular-dashboard/" class=" m-r-20 hidden-sm-up" mat-raised-button color="warn">Upgrade To Pro</a> -->
<button [matMenuTriggerFor]="profile" mat-icon-button class="m-r-5"> 
    <img src="assets/images/users/usr.png" alt="user" class="profile-pic"> 
    <i class="fas fa-user-tie"></i>
</button>
<mat-menu #profile="matMenu" class="mymegamenu">
    <!-- <button mat-menu-item>
        <mat-icon>settings</mat-icon> Settings </button>
    <button mat-menu-item>
        <mat-icon>account_box</mat-icon> Profile </button>
    <button mat-menu-item>
        <mat-icon>notifications_off</mat-icon> Disable notifications </button> -->
    <button mat-menu-item (click)="signOut()">
        <mat-icon>exit_to_app</mat-icon> Sign Out </button>
</mat-menu>

